export function formatQuantityDisplay(value, options = {}) {
  const { allowFractional = null, maxDecimals = 4 } = options
  const n = Number(value || 0)
  if (!Number.isFinite(n)) return '0'

  // If explicitly non-fractional, always show whole number
  if (allowFractional === false) {
    return String(Math.round(n))
  }

  // If explicitly fractional, or unknown
  // Show integer without decimals; otherwise trim to maxDecimals
  if (Math.abs(n - Math.round(n)) < 1e-9) {
    return String(Math.round(n))
  }

  const decimals = Math.max(0, Math.min(10, Number(maxDecimals) || 4))
  let s = n.toFixed(decimals)
  s = s.replace(/0+$/, '').replace(/\.$/, '')
  return s
}

export function stepFromAllowFractional(allowFractional) {
  return allowFractional ? '0.0001' : '1'
}


